import React, { useState } from "react";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { ColorRing } from 'react-loader-spinner'

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';

export default function AuthSearch() {

	const [spinner, setSpinner] = useState(false);
	const [postResult, setPostResult] = useState(null);
	const [postResult2, setPostResult2] = useState(null);
	const [id, setId] = React.useState('');
	const [cpt, setCPT] = React.useState('');
	const [dos, setDOS] = React.useState(null);
	const baseURL = "https://veritasallies.net/opensearch/authcheck";
	const DEFAULT_ORDER = 'asc';
	const DEFAULT_ORDER_BY = 'authId';
	//	const [order, setOrder] = React.useState(DEFAULT_ORDER);
	//	const [orderBy, setOrderBy] = React.useState(DEFAULT_ORDER_BY);
	//	const [visibleRows, setVisibleRows] = React.useState(null);
	let rows = [];
	let order = DEFAULT_ORDER;
	let orderBy = DEFAULT_ORDER_BY;

	const StyledTableCell = styled(TableCell)(({ theme }) => ({
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: theme.palette.common.black,
			color: theme.palette.common.white,
		},
		[`&.${tableCellClasses.body}`]: {
			fontSize: 14,
		},
	}));

	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
		// hide last border
		'&:last-child td, &:last-child th': {
			border: 0,
		},
	}));


	const headCells = [
		{
			id: 'firstname',
			label: 'First Name',
		},
		{
			id: 'lastName',
			label: 'Last Name',
		},
		{
			id: 'memberId',
			label: 'Member Id',
		},
		{
			id: 'authId',
			label: 'Auth Id',
		},
		{
			id: 'authstatus',
			label: 'Auth Status	',
		},
		{
			id: 'dos',
			label: 'DOS',
		},
		{
			id: 'dx',
			label: 'DX',
		},
		{
			id: 'cptCodes',
			label: 'CPT Code',
		}
	];


	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}



	// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
	// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
	// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
	// with exampleArray.slice().sort(exampleComparator)
	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) {
				return order;
			}
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	}


	function EnhancedTableHead(props) {
		console.log("Rendering Table Head ");

		console.log(props);
		const { order, orderBy, onRequestSort } =
			props;
		const createSortHandler = (newOrderBy) => (event) => {
			onRequestSort(event, newOrderBy);
		};

		return (
			<TableHead>
				<TableRow>
					{headCells.map((headCell) => (
						<TableCell
							key={headCell.id}
							sortDirection={orderBy === headCell.id ? order : false}
							align="center"
						>
							<TableSortLabel
								active={orderBy === headCell.id}
								direction={orderBy === headCell.id ? order : 'asc'}
								onClick={createSortHandler(headCell.id)}
							>
								{headCell.label}
								{orderBy === headCell.id ? (
									<Box component="span" sx={visuallyHidden}>
										{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
									</Box>
								) : null}
							</TableSortLabel>
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		);
	}

	const getComparator = (order, orderBy) => {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}


	EnhancedTableHead.propTypes = {
		onRequestSort: PropTypes.func.isRequired,
		order: PropTypes.oneOf(['asc', 'desc']).isRequired,
		orderBy: PropTypes.string.isRequired,
	};

	const handleRequestSort =
		(event, newOrderBy) => {

			const isAsc = orderBy === newOrderBy && order === 'asc';
			const toggledOrder = isAsc ? 'desc' : 'asc';
			order = toggledOrder;
			orderBy = newOrderBy;

			const sortedRows = stableSort(rows, getComparator(toggledOrder, newOrderBy));
			console.log("Sorted");
			console.log(sortedRows);
			rows = sortedRows;
			setPostResult(formatResponse(rows));
			console.log(postResult2);
		};


	const formatResponse = (dataReturn) => {

		const rList = dataReturn.map((r) => {
			return (
				<StyledTableRow
					key={r.key}
					sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
				>
					<StyledTableCell align="center" component="th" scope="row">{r.firstName}</StyledTableCell>
					<StyledTableCell align="center">{r.lastName}</StyledTableCell>
					<StyledTableCell align="center">{r.memberId}</StyledTableCell>
					<StyledTableCell align="center">{r.authId}</StyledTableCell>
					<StyledTableCell align="center">{r.status}</StyledTableCell>
					<StyledTableCell align="center">{r.dos}</StyledTableCell>
					<StyledTableCell align="center">{r.dx}</StyledTableCell>
					<StyledTableCell align="center">{r.cptCodes}</StyledTableCell>
				</StyledTableRow >
			);
		});

		rows = dataReturn;
		return (
			<div  sx={{ justifyContent: 'center' }}>
				<Stack spacing={2} direction="column" sx={{ margin: 'auto', width: '70%' }}>
					<TableContainer sx={{ minWidth: 850, boxSizing: "border-box" }} component={Paper} >
						<Table sx={{ minWidth: 850, boxSizing: "border-box"  }} aria-label="customized table">
							<EnhancedTableHead
								order={order}
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<TableBody>
								{rList}
							</TableBody>
						</Table>
					</TableContainer>
				</Stack>
			</div>
		);

	}

	async function getData() {

		let targetURL = baseURL + "/" + id;

		if (cpt !== '') {
			targetURL = baseURL + "/" + id + "/" + dos + "/" + cpt;
		} else if (dos !== null) {
			targetURL = baseURL + "/" + id + "/" + dos;
		}

		try {
			setSpinner(true);
			const res = await fetch(`${targetURL}`, {
				method: "get",
			});

			if (!res.ok && res.status !== 404) {
				const message = `An error has occured: ${res.status} - ${res.statusText}`;
				throw new Error(message);
			}

			const data = await res.json();

			const result = {
				status: res.status + "-" + res.statusText,
				headers: {
					"Content-Type": res.headers.get("Content-Type"),
					"Content-Length": res.headers.get("Content-Length"),
				},
				data: data
			};

			setSpinner(false);
			setPostResult(formatResponse(stableSort(result.data, getComparator(order, orderBy))));
		} catch (err) {
			setSpinner(false);
			setPostResult(err.message);
		}
	}

	const handleIdChange = (event) => {
		setId(event.target.value);
	};

	return (
		<div sx={{ justifyContent: "center" }}>
			<Stack spacing={2} direction="row" sx={{ justifyContent: "center" }}>
				<TextField id="outlined-basic" label="MemberId" variant="outlined"
					InputLabelProps={{
						shrink: true,
					}}
					onChange={handleIdChange} />
				<Button onClick={getData} variant="outlined">Search</Button>
				<ColorRing
					visible={spinner}
					height="80"
					width="80"
					ariaLabel="blocks-loading"
					wrapperStyle={{}}
					wrapperClass="blocks-wrapper"
					colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
				/>
			</Stack>
			<center><h2>{postResult && <div className="alert alert-secondary mt-2" role="alert"><pre>{postResult}</pre></div>}</h2></center>
		</div>
	);


}